export const INITIAL_CRYPTO_FORM_DATA = {
  account_type: 'crypto',
  currency: '',
  wallet_address: '',
  network: '',
  wallet_label: '',
  phone_number: '',
  otp: ''
};

export const CRYPTO_FORM_VALIDATION_MESSAGES = {
  CURRENCY_REQUIRED: 'Please select a cryptocurrency',
  WALLET_ADDRESS_REQUIRED: 'Wallet address is required',
  WALLET_ADDRESS_INVALID: 'Invalid wallet address',
  NETWORK_REQUIRED: 'Please select a network',
  WALLET_LABEL_REQUIRED: 'Wallet label is required',
  PHONE_REQUIRED: 'Phone number is required',
  PHONE_INVALID: 'Phone number must include country code (e.g., +919876543210)',
  OTP_REQUIRED: 'OTP is required'
};
